import { NoResults } from './NoResults';

const name = 'NoResults';
export { NoResults, name };

export type { NoResultsProps } from './types';
